<template>
  <div class="card text-base sm:text-lg self-start min-h-96 w-full max-w-md
    mx-2 sm:mx-4 p-2 sm:p-4" ref="popupel">
    <p class="font-bold">{{ $t('IntroKssTrackerOverlayComponent.kssTracker', { text: featureName }) }}</p>
    <div class="p-2 sm:p-4">
      <h2 class="text-[var(--color-orange)] mb-1 text-lg sm:text-xl">
        {{ data.assessment?.name }}</h2>
      <p class="font-normal text-sm sm:text-base">{{ date }}</p>

      <div class="flex p-4 sm:p-6 items-center justify-center text-center">
        <Button type="button" :disabled="buttonDisabled" @click.prevent="check"
            class="btn-primary-accent w-full sm:w-auto" unstyled>
          {{ $t('IntroKssTrackerOverlayComponent.participate') }}
        </Button>
      </div>
      <p class="font-bold text-sm sm:text-base" v-if="data.assessment?.description">
        {{ data.assessment.description }}</p>
    </div>
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="flex flex-row justify-center place-items-center min-w-0">
        <div class="w-12 sm:w-16 shrink-0">
          <img :src="getCreatorImage" alt="" class="w-10 h-10 sm:w-12 sm:h-12 overflow-hidden rounded-full">
        </div>
        <div class="w-full min-w-0 pl-2 text-left">
          <p class="text-sm sm:text-base font-bold">{{ $t('IntroKssTrackerOverlayComponent.creator') }}</p>
          <h3 class="text-base sm:text-lg break-words">{{ data.assessment?.creator?.name }}</h3>
        </div>
      </div>
      <div class="flex items-center justify-center w-full text-center py-4 sm:justify-end sm:px-4">
        <div>
            <Button type="button" @click.prevent="toggle" id="button-list"
                class="btn-secondary w-full sm:w-auto" :icon="getIcon"
                :label="$t('IntroKssTrackerOverlayComponent.cancel')"
                unstyled />
          <ul v-if="dropdownVisible" class="max-w-44 block absolute bg-[var(--color-milk)]
            border-[1px] border-[var(--color-orange)] rounded-3xl w-60 px-1 text-sm">
            <li class="list-none py-2">
              <Button type="button" :disabled="buttonDisabled"
                @click.prevent="cancelAssesment('notInThisParticularMeeting')"
                class="text-[var(--color-black)] bg-none border-b
                    border-b-[rgb(185,185,185)]" unstyled>
                    {{ $t('IntroKssTrackerOverlayComponent.didntParticipate') }}
              </Button>
            </li>
            <li class="list-none py-2">
              <Button type="button"
                @click.prevent="cancelAssesment('notInThisMeeting')"
                class="text-[var(--color-black)] bg-none border-b
                    border-b-[rgb(185,185,185)]" unstyled>
                {{ $t('IntroKssTrackerOverlayComponent.mistakeChoice') }}
              </Button>
            </li>
            <li class="list-none py-2">
              <Button type="button"
                @click.prevent="cancelAssesment('sentRepresentative')"
                class="text-[var(--color-black)] bg-none border-none" unstyled>
                {{ $t('IntroKssTrackerOverlayComponent.sentRepresentative') }}
              </Button>
            </li>
          </ul>
        </div>
       </div>
    </div>
  </div>

</template>

<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';
import { Button } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  components: { Button },
  props: {
    data: Object,
  },
  name: 'IntroKssTrackerOverlayComponent',
  data() {
    return {
      dropdownVisible: false,
      buttonDisabled: false,
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
    date() {
      const startDate = new Date(this.data.assessment.date_taskBegin);
      // const endDate = new Date(this.data.assessment.date_taskEnd);
      const day = this.$t(`IntroKssTrackerOverlayComponent.days.${startDate.getDay()}`);
      const month = this.$t(`KssCalendarComponent.months.${startDate.getMonth()}`);
      const startTime = `${(`0${startDate.getHours()}`).slice(-2)}:${(`0${startDate.getMinutes()}`).slice(-2)}`;
      // eslint-disable-next-line max-len
      // const sendTime = `${(`0${endDate.getHours()}`).slice(-2)}:${(`0${endDate.getMinutes()}`).slice(-2)}`;
      return `${day}, ${startDate.getDate()}. ${month} ${startDate.getFullYear()} ${startTime}`;// - ${sendTime}`;
    },
    getIcon() {
      if (this.dropdownVisible) {
        return 'pi pi-angle-up';
      }
      return 'pi pi-angle-down';
    },
    getCreatorImage() {
      if (this.data.assessment.creator?.picture_profile?.small) {
        return this.data.assessment.creator.picture_profile?.small;
      }
      return defaultProfileImage;
    },
  },
  methods: {
    scrollToElement() {
      const el = this.$refs.popupel;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    check() {
      this.$store.commit('removeFrontendOverlay', this.data.id);
    },
    toggle() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    async cancelAssesment(type) {
      try {
        this.buttonDisabled = true;
        await this.$store.dispatch('cancelKssTask', {
          assessmentID: this.data.assessment._id,
          reasons: [type],
        });
        this.$router.push('/');
        this.$store.commit('removeFrontendOverlay', this.data.id);
        this.buttonDisabled = false;
      } catch (error) {
        this.buttonDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: error.response.data.message,
          detail: '',
          life: 3000,
        });
      }
    },
  },
  mounted() {
    setTimeout(() => this.scrollToElement(), 150);
  },
};
</script>
